export const defaultCoverImage = 'https://cdn.discordapp.com/app-assets/1028340906740420711/1056826167933546576.png';
export const bsdpDataSource = 'ws://127.0.0.1:2946/BSDataPuller';
export const bsPlusDataSource = 'ws://127.0.0.1:2947/socket';

export const widerTimestampsSecondsThreshold = 180;
export const graphGridHorizontalStepsBase = 5;
